import { render, staticRenderFns } from "./ValidateCuttingPleatingOverviewPage.vue?vue&type=template&id=3fec5017"
import script from "./ValidateCuttingPleatingOverviewPage.vue?vue&type=script&lang=js"
export * from "./ValidateCuttingPleatingOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports